import { render } from "./Entrance.vue?vue&type=template&id=2852fcda&ts=true"
import script from "./Entrance.vue?vue&type=script&lang=ts"
export * from "./Entrance.vue?vue&type=script&lang=ts"

import "./Entrance.vue?vue&type=style&index=0&id=2852fcda&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__